import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { DashboardStatsSchema, type DashboardStats } from '@datazo/contracts';
import { apiFetch } from '@/shared/api/client';

export const dashboardKeys = {
  stats: ['dashboard', 'stats'] as const,
};

export function useDashboardStats(): UseQueryResult<DashboardStats, Error> {
  return useQuery({
    queryKey: dashboardKeys.stats,
    queryFn: () =>
      apiFetch<DashboardStats>('/api/dashboard/stats', { parseAs: DashboardStatsSchema }),
    staleTime: 30_000,
  });
}
